import {RoomService, SettingService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        sys: {},
        rooms: [],
        ncutRooms: [],
        mails: [],
        industry: {},
        specialMappings: [],
        periodsDefs: {
            collegePeriods: [...Array(17).keys()]
                .map(k => ({period: k + 1, text: ''})),
            dayPeriods: [...Array(17).keys()]
                .map(k => ({period: k + 1, text: ''}))
        },
        weekRanges:[]
    },
    getters: {
        schoolYear: state => state.sys.currentSchoolYear,
        semester: state => state.sys.currentSemester
    },
    mutations: {
        saveSys(current, sys) {
            current.sys = sys;
        },
        saveIndustry(current, industry) {
            current.industry = industry;
        },
        saveMails(current, mails) {
            current.mails.splice(0);
            current.mails = [...mails];
        },
        saveSpecialMappings(current, specialMappings) {
            current.specialMappings.splice(0);
            current.specialMappings = [...specialMappings];
        },

        saveRooms(current, rooms) {
            current.rooms.splice(0);
            current.rooms.push(...rooms);
        },
        savePeriodsDefs(current, defs) {
            current.periodsDefs = {...defs};
        },
        saveNcutRooms(current, rooms) {
            current.ncutRooms.splice(0);
            current.ncutRooms.push(...rooms);
        },
        saveWeekRanges(current, weekRanges) {
            current.weekRanges.splice(0);
            current.weekRanges.push(...weekRanges);
        }
    },
    actions: {
        async getSysAction({commit}) {
            await bindLoading(commit, async () => commit('saveSys', await SettingService.getSys()), 'setting')
        },
        async getIndustryAction({commit}) {
            await bindLoading(commit, async () => commit('saveIndustry', await SettingService.getIndustry()), 'setting')
        },

        async saveSysAction({commit}, sys) {
            return await bindLoading(commit, async () => {
                const result = await SettingService.updateSys(sys);
                if (result.success) {
                    commit('saveSys', sys);
                }
                return result;
            }, 'setting');

        },

        async saveIndustryAction({commit}, industry) {
            return await bindLoading(commit, async () => {
                const result = await SettingService.updateIndustry(industry);
                if (result.success) {
                    commit('saveIndustry', industry);
                }
                return result;
            }, 'setting');

        },

        async getRoomsAction({commit}) {
            await bindLoading(commit, async () => commit('saveRooms', await RoomService.getRooms()), 'setting');
        },

        async getNcutRoomsAction({commit}) {
            await bindLoading(commit, async () => commit('saveNcutRooms', await RoomService.getNcutRooms()), 'setting');
        },

        async updateRoomAction({commit, state}, room) {
            return await bindLoading(commit, async () => {
                const result = await SettingService.updateRoom(room);
                if (result.success) {
                    const newRooms = [...state.rooms.filter(r => r.id !== room.id), {...room}]
                        .sort((a, b) => a.id - b.id);
                    commit('saveRooms', newRooms);
                }
                return result;
            }, 'setting');

        },
        async insertRoomAction({commit, state}, room) {
            return await bindLoading(commit, async () => {

                const result = await SettingService.insertRoom({...room});

                if (result.success) {
                    const newRooms = [...state.rooms, result.instance];
                    commit('saveRooms', newRooms);
                }
                return result;
            }, 'setting');

        },
        async deleteRoomAction({commit, state}, id) {
            return await bindLoading(commit, async () => {

                const result = await SettingService.deleteRoom(id);

                if (result.success) {
                    const newRooms = [...state.rooms.filter(r => r.id !== id)];
                    commit('saveRooms', newRooms);
                }
                return result;
            }, 'setting');

        },

        async getMailsAction({commit}) {
            await bindLoading(commit, async () => commit('saveMails', await SettingService.getMails()), 'setting')
        },

        async getWeekRangesAction({commit}, params) {
            await bindLoading(commit,
                async () => commit('saveWeekRanges', await SettingService.getWeekRanges(params)), 'setting');
        },

        async getSpecialMappingsAction({commit}) {
            await bindLoading(commit, async () => commit('saveSpecialMappings'
                , await SettingService.getSpecialMappings()), 'setting')
        },

        async updateMailAction({commit, state}, mail) {
            return await bindLoading(commit, async () => {
                const result = await SettingService.updateMail(mail);
                if (result.success) {
                    const newMails = [...state.mails.filter(m => m.type !== mail.type), {...mail}];
                    commit('saveMails', newMails);
                }
                return result;
            }, 'setting');

        },
        async getPeriodsDefsAction({commit}) {
            await bindLoading(commit, async () => commit('savePeriodsDefs', await SettingService.getPeriodsDefs()), 'setting')
        },

        async downloadSpecialTimeTemplateAction() {
            const url = window.URL.createObjectURL(new Blob([await SettingService.downloadTemplate()]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', '特殊時段匯入樣板(空白).xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        async exportSpecialTimeSettingsAction() {
            const url = window.URL.createObjectURL(new Blob([await SettingService.downloadCurrent()]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', '本學年特殊時段設定.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    }
}